import { TrashIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type DeleteAttachmentDialogProps = {
  isDeleting?: boolean;
  onDelete: () => void;
  onClose: () => void;
};

export default function DeleteAttachmentDialog({
  isDeleting,
  onDelete,
  onClose,
}: DeleteAttachmentDialogProps) {
  return (
    <DefaultDialog
      pending={isDeleting}
      variant="confirm"
      icon={<TrashIcon size="1.375rem" />}
      confirmLabel="Remove"
      pendingLabel="Removing"
      title="Remove attachment"
      message="Are you sure you want to remove this attachment? This action cannot be undone."
      onCancel={onClose}
      onConfirm={onDelete}
      onClose={onClose}
    />
  );
}
